export function capitalize(string: string, options?: { allWords: boolean }): string {
  const stringSplit = string?.split(' ') ?? [''];
  return stringSplit
    .map((stringPart, wordIndex) =>
      (!!options?.allWords || wordIndex === 0
        ? stringPart.charAt(0).toUpperCase() + stringPart.slice(1).toLowerCase()
        : stringPart.toLowerCase()))
    .join(' ');
}
